import { useNotify, useTranslate } from "ra-core";
import { useNavigate } from "react-router";

import { useCloseRoutedForm } from "../misc/useMobileFormGuard";
import type { Company } from "../types";
import { CompanyCreateSheet } from "./CompanyCreateSheet";
import { CompanyListMobile } from "./CompanyListMobile";

/**
 * /companies/create on a phone: the create sheet over the company list.
 * Back or the x leaves the route; a successful save replaces it with the
 * new company's page (so Back doesn't reopen an empty form).
 */
export const CompanyCreateMobile = () => {
  const close = useCloseRoutedForm("/companies");
  const navigate = useNavigate();
  const notify = useNotify();
  const translate = useTranslate();
  return (
    <>
      <CompanyListMobile />
      <CompanyCreateSheet
        open
        onOpenChange={(open) => {
          if (!open) close();
        }}
        history={false}
        mutationOptions={{
          onSuccess: (data: Company) => {
            notify("resources.companies.notifications.created", {
              type: "info",
              messageArgs: {
                smart_count: 1,
                _: translate("ra.notification.created", { smart_count: 1 }),
              },
            });
            navigate(`/companies/${data.id}/show`, { replace: true });
          },
        }}
      />
    </>
  );
};
